import { PopoverHeading, Status, StatusPopover, formatDate, formatDateTime } from "@amber/ui";
import type { MemberRow } from "../../contracts/index";

export function MemberStatus({ row }: { row: MemberRow }) {
  if (row.kind === "invitation") {
    return (
      <StatusPopover
        label={<Status tone="invited">{row.expired ? "Invitation expired" : "Invited"}</Status>}
        accessibleLabel={`${row.expired ? "Invitation expired" : "Invited"}, details`}
      >
        <PopoverHeading>{row.expired ? "Invitation expired" : "Invitation pending"}</PopoverHeading>
        <p>
          {row.expired
            ? "The link no longer works. Invite the address again to send a new one."
            : "Waiting for this address to sign in with Google."}
        </p>
        <dl>
          <dt>Invited by</dt>
          <dd>{row.invited_by}</dd>
          <dt>Invited</dt>
          <dd>{formatDateTime(row.invited_at)}</dd>
          <dt>{row.expired ? "Expired" : "Expires"}</dt>
          <dd>{formatDate(row.expires_at)}</dd>
          {row.note ? (
            <>
              <dt>Note</dt>
              <dd>{row.note}</dd>
            </>
          ) : null}
        </dl>
      </StatusPopover>
    );
  }
  if (row.status === "deactivated") {
    return (
      <StatusPopover label={<Status tone="off">Deactivated</Status>} accessibleLabel="Deactivated, details">
        <PopoverHeading>Deactivated</PopoverHeading>
        <p>Can&apos;t sign in. Their work stays.</p>
        {row.status_detail ? (
          <dl>
            <dt>By</dt>
            <dd>{row.status_detail.by}</dd>
            <dt>When</dt>
            <dd>{formatDateTime(row.status_detail.at)}</dd>
            <dt>Reason</dt>
            <dd>{row.status_detail.reason}</dd>
          </dl>
        ) : null}
      </StatusPopover>
    );
  }
  return <Status tone="ok">Active</Status>;
}
